import { defaultLanguage } from 'shared/locale'

import { IUserSettingsStatePersisted } from 'features/userSettings/types'

type MigrationType = (state: IUserSettingsStatePersisted) => IUserSettingsStatePersisted

export const userSettingsMigrations: Record<string, MigrationType> = {
  2: state => ({
    ...state,
    data: {
      ...state.data,
      lang: defaultLanguage,
    },
  }),
  3: state => ({
    ...state,
    data: {
      ...state.data,
      lang: defaultLanguage,
    },
  }),
}
